<!--
  智能办公页面
  作者：陶璇
  时间：2023-8-14
-->
<template>
  <van-nav-bar
    safe-area-inset-top
    title="智能办公"
    z-index="2"
    style="height: 57px"
  >
    <template #title>
      <van-cell-group inset>
        <van-field
          v-model="state.sessionName"
          center
          type="text"
          size="large"
          input-align="center"
          placeholder="请输入提问"
          readonly="true"
          style="font-size: medium"
        >
          <!-- <template #button>
            <van-icon
              v-if="!(state.sessionId == undefined || state.sessionId == '' || state.isLoading)"
              name="edit"
              size="28"
            />
          </template> -->
          <template #left-icon>
            <img :src="state.currentModel.img" width="30" height="30" alt="" />
          </template>
        </van-field>
      </van-cell-group>
    </template>
    <template #right>
      <van-icon name="plus" size="28" @click="showAddSession" />
    </template>
    <template #left>
      <van-icon name="todo-list-o" size="28" @click="openSessionList" />
    </template>
  </van-nav-bar>
  <van-popup v-model:show="state.showAdd" style="height: 30%; width: 60%">
    <div style="font-size: 20px; height: 50%; display: flex; font-weight: bold">
      <van-button plain style="width: 80%; margin: auto" @click="clearQA">
        <template #icon>
          <van-icon name="chat" size="24" color="#1989fa" />
        </template>
        新建会话
      </van-button>
    </div>
    <div style="font-size: 20px; height: 50%; display: flex; font-weight: bold">
      <van-button plain style="width: 80%; margin: auto" @click="addAssistant">
        <template #icon>
          <van-icon name="manager" size="24" color="#1989fa" />
        </template>
        新建助手
      </van-button>
    </div>
  </van-popup>
  <van-popup v-model:show="state.showSessionList" position="left"> </van-popup>
  <div class="content">
    <!--  GPT聊天内容  -->
    <div class="v-chat-record" ref="recordRef">
      <van-pull-refresh
        v-model="state.loading"
        @refresh="pullDownRefresh()"
        success-text="刷新成功"
        loading-text="加载中"
      >
        <div
          class="v-chat-record-item"
          v-for="(item, idx) in state.QAList"
          :class="[
            item.type === 1
              ? 'v-chat-record-left-item'
              : 'v-chat-record-right-item',
          ]"
        >
          <div class="v-chat-record-item-box" v-if="item.type === 1">
            <img :src="item.img" alt="" />
            <div class="v-chat-record-item-child">
              <details
                v-if="item.think != undefined && item.think != ''"
                style="
                  color: gray;
                  background-color: #f8f8f8;
                  padding: 8px;
                  border-radius: 4px;
                  font-size: 14px;
                  width: 100%;
                "
                open
              >
                <summary>Thinking</summary>
                {{ item.think }}
              </details>
              <div v-if="isEchart(item)" style="overflow-x: auto">
                <Echart :content="item.content" :chart="item.echart" />
              </div>
              <div
                v-else-if="isMarkdown(item.content)"
                v-html="renderMarkdown(item.content)"
                style="word-wrap: break-word; overflow-x: auto"
              ></div>
              <span v-else style="white-space: pre-wrap">
                {{ item.content }}
              </span>
              <div class="vant-table" v-if="item.config != undefined">
                <table cellspacing="0" class="table">
                  <tr>
                    <th
                      class="th"
                      v-for="row in item.config"
                      :key="row.sort_num"
                      :style="'min-width:' + row.width + 'px'"
                    >
                      {{ row.column_name }}
                    </th>
                  </tr>
                  <tr v-for="rows in item.data" :key="rows.id">
                    <td align="center" v-for="row in rows" :key="row.id">
                      {{ row }}
                    </td>
                  </tr>
                  <tr v-if="item.data == null">
                    <td align="center" colspan="10">暂无数据</td>
                  </tr>
                </table>
              </div>
              <div
                style="
                  display: flex;
                  justify-content: flex-end;
                  margin-bottom: 5px;
                "
                v-if="item.id != null"
              >
                <!-- 时间 -->
                <span
                  style="
                    margin-right: 10px;
                    cursor: pointer;
                    line-height: 15px;
                    color: #9ca3af;
                  "
                  >{{ item.createTime }}</span
                >
                <!-- 复制 -->
                <van-icon
                  name="newspaper-o"
                  size="15"
                  style="margin-right: 10px; cursor: pointer"
                  @click="copyContent(item)"
                />
                <!-- 结果反馈 -->
                <img
                  src="@/assets/up.png"
                  v-if="item.feedback == 1"
                  style="
                    width: 15px;
                    height: 15px;
                    margin-right: 10px;
                    background-color: #409eff;
                    cursor: pointer;
                  "
                  @click="feedbackChange(idx, null)"
                />
                <img
                  src="@/assets/up.png"
                  v-else
                  style="
                    width: 15px;
                    height: 15px;
                    margin-right: 10px;
                    cursor: pointer;
                  "
                  @click="feedbackChange(idx, 1)"
                />
                <img
                  src="@/assets/down.png"
                  v-if="item.feedback == 0"
                  style="
                    width: 15px;
                    height: 15px;
                    background-color: #ff4a4a;
                    cursor: pointer;
                  "
                  @click="feedbackChange(idx, null)"
                />
                <img
                  src="@/assets/down.png"
                  v-else
                  style="width: 15px; height: 15px; cursor: pointer"
                  @click="feedbackChange(idx, 0)"
                />
              </div>
              <div style="width: 100%">
                <van-button
                  v-if="
                    item.search_type != undefined &&
                    item.search_type == 'search'
                  "
                  size="small"
                  round
                  type="default"
                  @click="showWebData(item)"
                  >{{ item.search_result.length }}篇资料<van-icon
                    name="arrow"
                  />
                </van-button>
              </div>
              <div style="width: 100%">
                <van-button
                  v-if="
                    item.search_type != undefined &&
                    item.search_type == 'retrieval'
                  "
                  size="small"
                  round
                  type="default"
                  @click="showKmsData(item)"
                  >{{ item.search_result.length }}篇资料<van-icon
                    name="arrow"
                  />
                </van-button>
              </div>
            </div>
          </div>
          <div class="v-chat-record-item-box v-chat-record-item-box_2" v-else>
            <div class="v-chat-record-item-child">{{ item.content }}</div>
            <div class="empName">{{ empName }}</div>
          </div>
        </div>
        <div
          class="v-chat-record-item-box v-chat-record-item"
          v-if="state.isWaitShow"
        >
          <img :src="state.currentModel.img" />
          <div class="v-chat-record-item-child">请稍后...</div>
        </div>
      </van-pull-refresh>
    </div>
    <!-- <IosBottom /> -->
    <!--  底部用户输入  -->
    <div class="v-chat-input" ref="inputRef">
      <van-cell-group inset>
        <div v-if="state.showFile">
          <span>仅识别附件中的文字</span>
          <van-row>
            <van-col span="8">
              <van-badge color="white">
                <div
                  style="
                    height: 50px;
                    width: 150px;
                    background-color: rgb(243 244 246);
                    border-radius: 10px;
                    margin-bottom: 5px;
                  "
                >
                  <van-icon
                    style="float: left; margin-left: 5px; margin-top: 5px"
                    name="orders-o"
                    size="38"
                  />
                  <div>
                    <div
                      style="
                        height: 30px;
                        align-items: center;
                        overflow: hidden;
                      "
                    >
                      {{ state.FileList.name }}
                    </div>
                    <div
                      style="
                        align-items: center;
                        color: #646566;
                        font-size: 12px;
                        margin-top: 5px;
                        margin-left: 5px;
                      "
                    >
                      {{ state.FileList.size + "B" }}
                    </div>
                  </div>
                </div>
                <template #content>
                  <van-icon name="cross" color="gray" @click="removeFile" />
                </template>
              </van-badge>
            </van-col>
          </van-row>
        </div>
        <van-field
          v-model="state.userInput"
          center
          :autosize="{ maxHeight: 200, minHeight: 20 }"
          type="textarea"
          placeholder="请输入提问"
          @blur="handleblur"
          style="background-color: #f3f4f6; border-radius: 15px"
          :readonly="state.isLoading"
        >
        </van-field>
        <van-button
          v-if="state.isDeepseek"
          @click="changeisDeepseek"
          round
          size="small"
          type="default"
          color="#ecf5ff"
          style="
            margin-top: 10px;
            margin-right: 10px;
            margin-bottom: 5px;
            color: #409eff;
          "
          >深度思考</van-button
        >
        <van-button
          v-else="state.isDeepseek"
          @click="changeisDeepseek"
          round
          size="small"
          type="default"
          color="#f3f4f6"
          style="
            margin-top: 10px;
            margin-right: 10px;
            margin-bottom: 5px;
            color: #000;
          "
          >深度思考</van-button
        >
        <van-button
          v-if="state.isSearch"
          @click="changeisSearch"
          round
          size="small"
          type="default"
          color="#ecf5ff"
          style="margin-right: 10px; color: #409eff"
          >联网搜索</van-button
        >
        <van-button
          v-else="state.isSearch"
          @click="changeisSearch"
          round
          size="small"
          type="default"
          color="#f3f4f6"
          style="margin-right: 10px; color: #000"
          >联网搜索</van-button
        >
        <van-button
          v-if="state.isKms"
          @click="changeisKms"
          round
          size="small"
          type="default"
          color="#ecf5ff"
          style="margin-right: 10px; color: #409eff"
          >本地知识库</van-button
        >
        <van-button
          v-else="state.isKms"
          @click="changeisKms"
          round
          size="small"
          type="default"
          color="#f3f4f6"
          style="margin-right: 10px; color: #000"
          >本地知识库</van-button
        >
        <van-icon
          v-if="!state.isLoading"
          size="28"
          name="upgrade"
          color="#1989fa"
          style="top: 10px; float: right"
          @click="handleSubmit"
        />
        <van-icon
          v-else
          size="28"
          name="stop-circle-o"
          color="#1989fa"
          style="top: 10px; float: right"
          @click="abortStream"
        />
        <van-uploader
          :disabled="state.isSearch || state.isKms"
          accept=".pdf,.doc,.docx,.ppt,.pptx,.txt,.xlsx,.xls"
          :after-read="afterRead"
          style="top: 11px; right: 10px; top: 10px; float: right"
        >
          <van-icon size="24" name="plus" />
        </van-uploader>
        <div
          style="
            width: 100%;
            text-align: center;
            line-height: 14px;
            color: #a3a3a3;
            margin: 6px 0;
          "
        >
          内容由 AI 生成，请仔细甄别
        </div>

        <van-action-sheet v-model:show="state.showKmsData" title="知识库资料">
          <van-collapse
            v-model="state.kmsActive"
            v-for="(site, index) in state.searchKmsData"
            :key="index"
          >
            <van-collapse-item :title="site.title" :name="index">
              {{ site.content }}
            </van-collapse-item>
          </van-collapse>
        </van-action-sheet>
        <van-action-sheet v-model:show="state.showWebData" title="网络资料">
          <van-collapse
            v-model="state.webActive"
            v-for="(site, index) in state.searchWebData"
            :key="index"
          >
            <van-collapse-item  :title="site.Title" :name="index">
              <div @click="OpenLink(site.Url)">{{ site.Snippet }}</div>
            </van-collapse-item>
          </van-collapse>
        </van-action-sheet>
      </van-cell-group>
      <!-- <IosBottom /> -->
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
import {
  computed,
  nextTick,
  onMounted,
  reactive,
  ref,
  onBeforeUnmount,
  watch,
} from "vue";
import ChangeTitle from "@/utils/changeTitle";
import store from "@/store";
import { UserStore } from "@/store/userStore";
import { storeToRefs } from "pinia";
import IosBottom from "@/components/IosBottom.vue";
import {
  GetSessionRecord,
  SaveSession,
  GetAssistantSessionPages,
  UpdateSessionById,
  AIUploadFile,
} from "@/api/Oa/chatGpt";
import axios from "axios";
import { Toast, Dialog, Notify } from "vant";
import moment from "moment";
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
import * as dd from "dingtalk-jsapi";
import { isIOS } from "@/utils/utils";
import Echart from "../chatGPT/echart.vue";

moment.locale("zh-cn");
let observer = null;
const router = useRouter();
const route = useRoute();
const userStore = UserStore();
const { userInfo } = storeToRefs(userStore);
const inputRef = ref(null); // 输入框
const recordRef = ref(null); // 聊天内容
const md = new MarkdownIt().set({
  html: true,
  breaks: true,
  typographer: true,
  linkify: true,
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return (
          '<pre class="hljs" style="overflow-x: auto;"><code>' +
          hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
          "</code></pre>"
        );
      } catch (__) {}
    }
    return (
      '<pre class="hljs" style="overflow-x: auto;" ><code>' +
      md.utils.escapeHtml(str) +
      "</code></pre>"
    );
  },
});
md.use((md) => {
  // 获取默认的图片渲染规则
  const defaultRender =
    md.renderer.rules.image ||
    ((tokens, idx, options, env, self) => {
      return self.renderToken(tokens, idx, options);
    });

  md.renderer.rules.image = (tokens, idx, options, env, self) => {
    tokens[idx].attrs.forEach((attr) => {
      if (attr[0] === "src") {
        // 可以根据实际需求修改这里的样式
        // 比如给img标签添加class或者直接设置宽度样式
        attr.push(["style", "width: 100%;"]); // 这里为图片设置了 100% 宽度
      }
    });

    // 返回修改后的图片标签
    return defaultRender(tokens, idx, options, env, self);
  };
});
const state = reactive({
  recordData: [
    { id: 1, title: "操作" },
    { id: 2, title: "发起时间" },
    { id: 3, title: "消息名称" },
  ],
  recordList: [], //历史记录数据
  QAList: [],
  userInput: "", // 用户输入
  isLoading: false, // 是否正在加载
  isWaitShow: false, // 是否显示等待
  isInterfaceCode: false, //控制是否发起请假请求
  interfaceCode: false,
  bodyList: null, //存储的请假数据
  showAdd: false, //新建会话

  loading: false,
  currentModel: {}, //当前助手
  page: 1,
  pageSize: 10,
  total: 0,
  sessionId: route.query.sessionId, //sessionID
  sessionName: route.query.sessionName,
  readonly: true,
  history: [], //历史记录

  //中断请求
  controller: null,

  isKms: false,
  isSearch: false,
  isDeepseek: false,
  document_Templates: "",

  showSessionList: false,

  showFile: false,
  FileList: [], //上传文件列表

  showKmsData: false, //知识库资料数据
  kmsActive: ref(["1"]), //默认展开
  searchKmsData: "", //搜索知识库资料

  showWebData: false, //网络搜索数据
  webActive: ref(["1"]), //默认展开
  searchWebData: "", //搜索网络数据
});

// 员工姓名
const empName = computed(() => {
  return userInfo.value?.user?.emp_name.slice(-2);
});

// 移动到底部
const moveToBottom = () => {
  nextTick(() => {
    let div = document.getElementsByClassName("v-chat-record")[0];
    div.scrollTop = div.scrollHeight;
  });
};
//提问
const handleSubmit = async () => {
  if (state.isLoading) {
    return;
  }
  if (!state.userInput.trim()) return;
  if (state.sessionId == undefined || state.sessionId == "") {
    let session_id = await AddSession();
    if (session_id == null) {
      return;
    }
  }
  state.isLoading = true;
  state.isWaitShow = true;
  state.QAList.push({
    type: 2,
    content: state.userInput,
    role: "user",
  });
  moveToBottom();
  let token = localStorage.getItem("Token");

  if (state.userInput == "Y" && state.isInterfaceCode) {
    axios
      .post(
        "/oa_pub/oa/pub/GPT/GetFunctions",
        { body: state.bodyList, interfaceCode: state.interfaceCode },
        {
          headers: {
            Authorization: token,
            tenant_id: localStorage.getItem("tenant_id"),
          },
        }
      )
      .then((rex) => {
        state.QAList.push({
          img: state.currentModel.img,
          type: 1,
          role: "assistant",
          content: rex.data.msg,
        });
        state.isInterfaceCode = false;
        state.bodyList = null;
        state.interfaceCode = "";
        state.userInput = "";
        moveToBottom();
        state.isLoading = false;
        state.isWaitShow = true;
      });
    return;
  } else {
    // setTimeout(async () => {
    //   moveToBottom();
    //   let url = `/oa_ai/oa/ai/Chat/GetAssistantAnswer`;
    //   let body = {
    //     session_id: state.sessionId,
    //     question: state.userInput,
    //   };
    //   const request = new Request(url, {
    //     method: "post",
    //     body: JSON.stringify(body),
    //     headers: { "Content-Type": "application/json" },
    //   });
    //   request.headers.append("Authorization", token);
    //   request.headers.append("tenant_id", localStorage.getItem("tenant_id"));
    //   //request.headers.append('Content-Type', 'application/json');
    //   request.headers.append("Accept", "application/json, text/plain, */*");
    //   const stream = await fetch(request);
    //   const reader = stream.body.getReader();
    //   let textChunk = "";
    //   state.QAList.push({
    //     img: state.currentModel.img,
    //     type: 1,
    //     role: "assistant",
    //     content: textChunk,
    //   });
    //   let isTable = false;
    //   let resFormat = "";
    //   while (true) {
    //     const { done, value } = await reader.read();
    //     if (done) {
    //       // 流已完成
    //       if (isTable && resFormat != "") {
    //         resFormat = JSON.parse(resFormat);
    //         state.QAList[state.QAList.length - 1].data = resFormat.body;
    //         state.QAList[state.QAList.length - 1].config = resFormat.config;
    //       }
    //       state.isLoading = false;
    //       state.isWaitShow = false;
    //       state.userInput = "";
    //       break;
    //     }
    //     // 处理接收到的chunk
    //     var decoder = new TextDecoder().decode(value);
    //     if (
    //       decoder.substring(0, 1) == "{" &&
    //       decoder.includes("resFormat") &&
    //       decoder.includes("table")
    //     ) {
    //       isTable = true;
    //     }
    //     if (isJSON(decoder)) {
    //       decoder = JSON.parse(decoder);
    //     }
    //     if (decoder.resFormat != undefined) {
    //       state.QAList[state.QAList.length - 1].data = decoder.body;
    //       state.QAList[state.QAList.length - 1].config = decoder.config;
    //     } else if (isTable) {
    //       resFormat += decoder;
    //     } else if (decoder.interface_code != undefined) {
    //       let dataList = "";
    //       for (const key in decoder.display[0]) {
    //         dataList += key + ":" + decoder.display[0][key] + "" + "\n";
    //       }
    //       dataList = dataList + "输入Y继续发起请求,输入N取消该次请求。";
    //       state.QAList[state.QAList.length - 1].content = dataList;
    //       state.isInterfaceCode = true;
    //       state.bodyList = decoder.body[0];
    //       state.interfaceCode = decoder.interface_code;
    //       state.isLoading = false;
    //       state.isWaitShow = false;
    //     } else {
    //       var arr = new TextDecoder().decode(value).split("");
    //       state.isWaitShow = false;
    //       for (const [index, item] of arr.entries()) {
    //         await new Promise((resolve) => setTimeout(resolve, 30));
    //         state.QAList[state.QAList.length - 1].content += item;
    //       }
    //       state.isInterfaceCode = false;
    //       moveToBottom();
    //     }
    //   }
    // });
    setTimeout(async () => {
      moveToBottom();
      state.controller = new AbortController();
      const url = `/oa_ai/oa/ai/Chat/GetAssistantAnswer`;
      try {
        const stream = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
            tenant_id: localStorage.getItem("tenant_id"),
            Accept: "application/json, text/plain, */*",
            Connection: "close",
          },
          body: JSON.stringify({
            session_id: state.sessionId,
            question: state.userInput,
            search_enabled: state.isSearch,
            thinking_enabled: state.isDeepseek,
            kms_enabled: state.isKms,
            document_Templates: state.document_Templates,
          }),
          signal: state.controller.signal, // 绑定中断信号
        });
        const reader = stream.body.getReader();
        let textChunk = "";
        state.isWaitShow = false;
        state.QAList.push({
          img: state.currentModel.img,
          type: 1,
          role: "assistant",
          content: textChunk,
        });
        let isTable = false;
        let resFormat = "";
        let assistantContent = "";
        while (true) {
          if (state.controller.signal.aborted) {
            console.log("请求已被中止");
            await reader.cancel();
            break;
          }
          const { done, value } = await reader.read();
          // console.log(done);
          if (done) {
            // 流已完成
            if (isTable && resFormat != "") {
              resFormat = JSON.parse(resFormat);
              // console.log(resFormat);
              state.QAList[state.QAList.length - 1].data = resFormat.body;
              state.QAList[state.QAList.length - 1].config = resFormat.config;
            }
            // methods.checkAndOpenLink(state.QAList[state.QAList.length - 1].content);
            (state.QAList[state.QAList.length - 1].feedback = null),
              (state.QAList[state.QAList.length - 1].createTime = getDate());
            state.isLoading = false;
            state.isWaitShow = false;
            state.userInput = "";
            break;
          }
          // 处理接收到的chunk
          var decoder = new TextDecoder().decode(value);
          // 可能获取到多个JSON对象,拆分为行
          const lines = decoder
            .split("\n")
            .filter((line) => line.trim() !== "");
          //console.log(lines);

          for (const line of lines) {
            if (line.includes("data: ")) {
              // 转换为json字符串
              const jsonStr = line.replace("data: ", "");
              // 检查是否结束
              if (jsonStr === "[DONE]") {
                console.log("流式响应完成，读取完毕");
                continue;
              }
              //转换为js对象
              try {
                if (!isJSON(jsonStr)) {
                  console.log("不是JSON：", jsonStr);
                } else {
                  const jsData = JSON.parse(jsonStr);
                  if (jsData.choices[0].delta.content) {
                    var content = jsData.choices[0].delta.content;
                    assistantContent += content;
                    state.QAList[state.QAList.length - 1].id =
                      jsData.choices[0].chat_id;
                    const format = jsData.choices[0].format;
                    //判断是否是表格
                    if (format === "table") {
                      isTable = true;
                    }
                    if (isJSON(content)) {
                      content = JSON.parse(content);
                    }
                    if (content.resFormat != undefined) {
                      if (content.body == null) {
                        state.QAList[state.QAList.length - 1].data = undefined;
                        state.QAList[state.QAList.length - 1].content =
                          "暂无数据";
                      } else {
                        state.QAList[state.QAList.length - 1].data =
                          content.body;
                        state.QAList[state.QAList.length - 1].config =
                          content.config;
                      }
                    } else if (isTable) {
                      resFormat += content;
                    } else if (content.interfaceCode != undefined) {
                      let dataList = "";
                      for (const key in content.display[0]) {
                        dataList +=
                          key + "：" + content.display[0][key] + "" + "\n";
                      }
                      dataList =
                        dataList + "输入Y继续发起请求，输入N取消该次请求。";
                      state.QAList[state.QAList.length - 1].content = dataList;
                      state.isInterfaceCode = true;
                      state.bodyList = content.body[0];
                      state.interfaceCode = content.interfaceCode;
                      state.isShow = false;
                      state.isWaitShow = false;
                    } else if (format == "search") {
                      state.QAList[state.QAList.length - 1].search_type =
                        format;
                      state.QAList[state.QAList.length - 1].search_result =
                        content;
                      assistantContent = "";
                    } else if (format == "retrieval") {
                      state.QAList[state.QAList.length - 1].search_type =
                        format;
                      state.QAList[state.QAList.length - 1].search_result =
                        content;
                      assistantContent = "";
                    } else {
                      //更新message
                      var think = isThink(assistantContent);
                      state.QAList[state.QAList.length - 1].think = think;
                      await new Promise((resolve) => setTimeout(resolve, 1));
                      content = assistantContent
                        .replace(think, "")
                        .replace("<think>", "")
                        .replace("</think>", "")
                        .replace(/\[\[引用:(\d+)\]\]/g, (_, id) => {
                          return ``;
                        });
                      if (content.startsWith("\n\n")) {
                        content = content.substring(2);
                      }
                      state.QAList[state.QAList.length - 1].content = content;
                      state.isInterfaceCode = false;
                      moveToBottom();
                    }
                  }
                }
              } catch (e) {
                console.error("解析JSON失败:", e, jsonStr);
              }
            }
          }
        }
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("用户主动取消请求");
        } else {
          console.error("请求失败:", error);
        }
      }
    });
  }
};

const abortStream = () => {
  if (state.controller) {
    state.controller.abort();
    state.controller = null;
    state.isLoading = false;
    state.isWaitShow = false;
    state.userInput = "";
    moveToBottom();
  }
};

//历史对话
const openSessionList = () => {
  if (!state.isLoading) {
    router.push({
      name: "chatList",
      params: {
        modelId: state.currentModel.model_id,
      },
    });

    //state.showSessionList = true;
  }
};

//新增助手列表
const addAssistant = () => {
  router.push({
    name: "assistantList",
    params: { modelId: state.currentModel.model_id },
  });
};
//新增选择界面
const showAddSession = () => {
  if (!state.isLoading) {
    state.showAdd = true;
  }
};
//新建对话
const AddSession = async () => {
  let data = {
    isAdd: true,
    session_name: state.userInput.substring(0, 10),
  };
  let res = await SaveSession(data);
  if (res.code == 200) {
    state.sessionId = res.data;
    state.sessionName = state.userInput.substring(0, 10);
    return res.data;
  } else {
    Notify({ type: "danger", message: res.msg });
    return null;
  }
};
const EditSession = () => {
  let data = {
    session_name: state.sessionName,
    id: state.sessionId,
  };
  SaveSession(data).then((res) => {
    if (res.code == 200) {
      Toast("编辑成功");
      state.readonly = true;
    } else {
      Notify({ type: "danger", message: res.msg });
    }
  });
};

//清空对话
const clearQA = () => {
  state.currentModel.img = require("@/assets/default-chat.png");
  state.QAList = [
    {
      img: state.currentModel.img,
      type: 1,
      content: "你好！请问有什么我可以帮助你的吗？",
      role: "assistant",
    },
  ];
  state.sessionName = "未命名对话";
  state.sessionId = undefined;
  state.showAdd = false;
};

// 获取会话列表
const getSession = async () => {
  await GetAssistantSessionPages({ isAssist: true }).then((res) => {
    if (res.success && res.data.length > 0) {
      //是否首次进入
      if (state.sessionId == undefined) {
        state.currentModel = res.data[0];
        if (state.currentModel.file_id) {
          state.currentModel.img = `/oa_portal/oa/portal/Common/DownloadFile/${state.currentModel.file_id}?tenant_id=${state.currentModel.tenant_id}`;
        } else {
          state.currentModel.img = require("@/assets/default-chat.png");
        }
        state.sessionId = res.data[0].id;
        state.sessionName = res.data[0].session_name;
      } else {
        state.currentModel = res.data.filter(
          (item) => item.id == state.sessionId
        )[0];
        if (state.currentModel.file_id) {
          state.currentModel.img = `/oa_portal/oa/portal/Common/DownloadFile/${state.currentModel.file_id}?tenant_id=${state.currentModel.tenant_id}`;
        } else {
          state.currentModel.img = require("@/assets/default-chat.png");
        }
      }
    } else {
      Notify({ type: "warning", message: res.msg });
    }
  });
};
//下拉加载历史记录
const pullDownRefresh = () => {
  state.page++;
  getHistory(false);
  state.loading = false;
};
//获取历史记录
const getHistory = (value) => {
  let params = {
    page: state.page,
    pageSize: state.pageSize,
    session_id: state.sessionId,
  };
  GetSessionRecord(params).then((res) => {
    if (res.success) {
      if (res.data.length == 0 && state.page == 1) {
        state.QAList = [
          {
            img: state.currentModel.img,
            type: 1,
            content: state.currentModel.description,
            role: "assistant",
          },
        ];
      }
      state.history = res.data;
      state.history.reverse();
      state.history.map((item) => {
        if (item.res_format == "table" || item.res_format == "from") {
          let resFormat = JSON.parse(item.answer);
          if (resFormat.body == null) {
            state.QAList.unshift({
              img: state.currentModel.img,
              type: 1,
              content: "暂无数据",
              role: "",
              data: undefined,
              feedback: item.feedback,
              id: item.id,
              search_type: item.search_type,
              search_result: JSON.parse(item.search_result),
              createTime: formatDate(item.create_time),
            });
          } else {
            if (resFormat.interface_code != undefined) {
              let dataList = "";
              for (const key in resFormat.display[0]) {
                dataList += key + "：" + resFormat.display[0][key] + "" + "\n";
              }
              state.QAList.unshift({
                img: state.currentModel.img,
                type: 1,
                role: "assistant",
                data: undefined,
                content: dataList,
                feedback: item.feedback,
                id: item.id,
                search_type: item.search_type,
                search_result: JSON.parse(item.search_result),
                createTime: formatDate(item.create_time),
              });
              state.bodyList = resFormat.body[0];
              state.interfaceCode = resFormat.interfaceCode;
            } else {
              state.QAList.unshift({
                img: state.currentModel.img,
                type: 1,
                role: "",
                content: "",
                data: resFormat.body,
                config: resFormat.config,
                feedback: item.feedback,
                id: item.id,
                search_type: item.search_type,
                search_result: JSON.parse(item.search_result),
                createTime: formatDate(item.create_time),
              });
            }
          }
          state.QAList.unshift({
            type: 2,
            role: "user",
            content: item.question,
          });
        } else {
          var content = item.answer;
          var think = isThink(item.answer);
          content = content
            .replace(think, "")
            .replace("<think>", "")
            .replace("</think>", "")
            .replace(/＜think＞(.*?)＜\/think＞/gs, "")
            .replace(/\[\[引用:(\d+)\]\]/g, (_, id) => {
              return ``;
            });
          if (content.startsWith("\n\n")) {
            content = content.substring(2);
          }
          state.QAList.unshift({
            img: state.currentModel.img,
            type: 1,
            role: "assistant",
            content: content,
            think: think,
            feedback: item.feedback,
            id: item.id,
            search_type: item.search_type,
            search_result: JSON.parse(item.search_result),
            createTime: formatDate(item.create_time),
          });
          state.QAList.unshift({
            type: 2,
            role: "user",
            content: item.question,
          });
        }
      });
      //是否滚动到底部
      if (value) {
        moveToBottom();
      }
    } else {
      Notify({ type: "warning", message: res.msg });
    }
  });
};
// 初始化数据
const initData = async () => {
  // 获取初始模型
  await getSession();
  userStore.getUserInfo();

  observer = new ResizeObserver((entries) => {
    for (let entry of entries) {
      // 获取内容高度（不包含 padding 和 border）
      const contentHeight = entry.contentRect.height;
      handleHeightChange(contentHeight);
    }
  });
  // 开始观察元素
  if (inputRef.value) {
    observer.observe(inputRef.value);
  }

  // // 获取inputRef自身的高度
  // let inputHeight = inputRef.value.offsetHeight + 57;
  // // if(isIOS()){
  // //   inputHeight += 34
  // // }
  // // 设置recordRef的高度
  // recordRef.value.style.height = `calc(100vh - ${inputHeight}px)`;
  if (state.sessionId != undefined) {
    state.sessionName =
      state.sessionName == undefined ? "未命名对话" : state.sessionName;
    // 获取历史记录
    getHistory(true);
    moveToBottom();
  }
};

const isJSON = (str) => {
  if (typeof str == "string") {
    try {
      var obj = JSON.parse(str);
      if (typeof obj == "object" && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
};

//ios 复位
const handleblur = () => {
  window.scrollTo(0, 0);
};

// 判断是否是markdown格式
const isMarkdown = (text) => {
  const markdownFeatures = [
    /^#{1,6}\s+.*$/gm, // 标头
    /\*.*?\*/g, // 粗体
    /_.+?_/g, // 强调
    /^\s*[*+-]\s+/gm, // ul列表
    /^\s*\d+\.\s+/gm, // ol列表
    /^>.*$/gm, // 区块引用
    /~~~[\s\S]+?~~~/, // 有围栏的代码块
    /```[\s\S]+?```/, // 代码块
    /\[.*?\]\(.*?\)/, // 链接
    /!\[.*?\]\(.*?\)/, // 图片
    /\|.*?\|/g, // 表格
  ];
  return markdownFeatures.some((regex) => regex.test(text));
};
// 转换markdown格式
const renderMarkdown = (text) => {
  return md.render(text);
};

const changeisKms = () => {
  if (state.document_Templates != "") {
    Notify({ type: "warning", message: "文件解析和知识库不能同时开启" });
    state.isKms = false;
    return;
  }
  if (state.isSearch) {
    Notify({ type: "warning", message: "联网搜索和知识库不能同时开启" });
    state.isKms = false;
    return;
  }
  state.isKms = !state.isKms;
};

const changeisSearch = () => {
  if (state.document_Templates != "") {
    Notify({ type: "warning", message: "文件解析和联网搜索不能同时开启" });
    state.isSearch = false;
    return;
  }
  if (state.isKms) {
    Notify({ type: "warning", message: "知识库和联网搜索不能同时开启" });
    state.isSearch = false;
    return;
  }
  state.isSearch = !state.isSearch;
};
const changeisDeepseek = () => {
  state.isDeepseek = !state.isDeepseek;
};

// 判断是否是think标签
const isThink = (data) => {
  let match;
  var result = "";
  data = data
    .replace(/＜think＞/g, "<think>")
    .replace(/＜\/think＞/g, "</think>");
  const thinkTagRegex = /<think>(.*?)<\/think>/gs;
  const thinkStartRegex = /<think>(.*)/s;
  //console.log(data,"<think>","＜think＞＜/think＞");
  // 检查是否同时存在 <think> 和 </think>
  if ((match = thinkTagRegex.exec(data)) !== null) {
    result = match[1]; // 获取 <think></think> 中间的内容
  } else if ((match = thinkStartRegex.exec(data)) !== null) {
    result = match[1]; // 获取 <think> 后面所有内容
  } else {
    result = null; // 没有匹配到任何内容
  }
  return result;
};

// 判断是否是Echart
const isEchart = (item) => {
  var ischart = false;
  if (item.echart != undefined) {
    return true;
  }

  var content = item.content;

  //"```echarts\n{\n  \"legend\": {},\n  \"tooltip\": {},\n  \"dataset\": {\n    \"source\": [\n      [\n        \"产品\",\n        \"1月\",\n        \"2月\",\n        \"3月\",\n        \"4月\",\n        \"5月\",\n        \"6月\",\n        \"7月\",\n        \"8月\",\n        \"9月\",\n        \"10月\",\n        \"11月\",\n        \"12月\"\n      ],\n      [\n        \"产品A\",\n        41.1,\n        30.4,\n        65.1,\n        58.7,\n        60.2,\n        63.5,\n        64.5,\n        65.5,\n        66.5,\n        67.5,\n        68.5,\n        69.5\n      ],\n      [\n        \"产品B\",\n        86.5,\n        92.1,\n        85.7,\n        89.2,\n        89.2,\n        90.0,\n        91.0,\n        92.0,\n        93.0,\n        94.0,\n        95.0,\n        96.0\n      ],\n      [\n        \"产品C\",\n        24.1,\n        67.2,\n        35.6,\n        65.6,\n        65.6,\n        62.9,\n        63.9,\n        64.9,\n        65.9,\n        66.9,\n        67.9,\n        68.9\n      ],\n      [\n        \"产品D\",\n        36.8,\n        21.9,\n        58.4,\n        34.1,\n        34.1,\n        33.5,\n        34.5,\n        35.5,\n        36.5,\n        37.5,\n        38.5,\n        39.5\n      ]\n    ]\n  },\n  \"xAxis\": [\n    {\n      \"type\": \"category\",\n      \"gridIndex\": 0\n    },\n    {\n      \"type\": \"category\",\n      \"gridIndex\": 1\n    },\n    {\n      \"type\": \"category\",\n      \"gridIndex\": 0\n    },\n    {\n      \"type\": \"category\",\n      \"gridIndex\": 1\n    }\n  ],\n  \"yAxis\": [\n    {\n      \"gridIndex\": 0\n    },\n    {\n      \"gridIndex\": 1\n    },\n    {\n      \"gridIndex\": 0\n    },\n    {\n      \"gridIndex\": 1\n    }\n  ],\n  \"grid\": [\n    {\n      \"bottom\": \"55%\"\n    },\n    {\n      \"top\": \"55%\"\n    }\n  ],\n  \"series\": [\n    {\n      \"type\": \"bar\",\n      \"seriesLayoutBy\": \"row\"\n    },\n    {\n      \"type\": \"bar\",\n      \"seriesLayoutBy\": \"row\"\n    },\n    {\n      \"type\": \"bar\",\n      \"seriesLayoutBy\": \"row\"\n    },\n    {\n      \"type\": \"bar\",\n      \"seriesLayoutBy\": \"row\"\n    },\n    {\n      \"type\": \"bar\",\n      \"xAxisIndex\": 1,\n      \"yAxisIndex\": 1\n    },\n    {\n      \"type\": \"bar\",\n      \"xAxisIndex\": 1,\n      \"yAxisIndex\": 1\n    },\n    {\n      \"type\": \"bar\",\n      \"xAxisIndex\": 1,\n      \"yAxisIndex\": 1\n    },\n    {\n      \"type\": \"bar\",\n      \"xAxisIndex\": 1,\n      \"yAxisIndex\": 1\n    },\n    {\n      \"type\": \"bar\",\n      \"xAxisIndex\": 1,\n      \"yAxisIndex\": 1\n    },\n    {\n      \"type\": \"bar\",\n      \"xAxisIndex\": 1,\n      \"yAxisIndex\": 1\n    },\n    {\n      \"type\": \"line\",\n      \"seriesLayoutBy\": \"row\"\n    },\n    {\n      \"type\": \"line\",\n      \"seriesLayoutBy\": \"row\"\n    },\n    {\n      \"type\": \"line\",\n      \"seriesLayoutBy\": \"row\"\n    },\n    {\n      \"type\": \"line\",\n      \"seriesLayoutBy\": \"row\"\n    },\n    {\n      \"type\": \"line\",\n      \"xAxisIndex\": 1,\n      \"yAxisIndex\": 1\n    },\n    {\n      \"type\": \"line\",\n      \"xAxisIndex\": 1,\n      \"yAxisIndex\": 1\n    },\n    {\n      \"type\": \"line\",\n      \"xAxisIndex\": 1,\n      \"yAxisIndex\": 1\n    },\n    {\n      \"type\": \"line\",\n      \"xAxisIndex\": 1,\n      \"yAxisIndex\": 1\n    },\n    {\n      \"type\": \"line\",\n      \"xAxisIndex\": 1,\n      \"yAxisIndex\": 1\n    },\n    {\n      \"type\": \"line\",\n      \"xAxisIndex\": 1,\n      \"yAxisIndex\": 1\n    }\n  ]\n}\n```";
  const pattern = /```echarts([\s\S]*?)```/gm;
  const matches = [];
  let match;
  while ((match = pattern.exec(content)) !== null) {
    const chartOptionsStr = match[1];
    try {
      item.echart = chartOptionsStr;
      ischart = true;
    } catch (error) {
      console.error("Invalid ECharts configuration:", error);
    }
  }

  // 处理非图表内容（文本）
  const nonChartContent = content.replace(pattern, "");
  item.content = nonChartContent;
  //console.log(item, ischart);
  return ischart;
};

const getDate = () => {
  var date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};
//格式化日期
const formatDate = (cellValue) => {
  if (cellValue != "" && cellValue != null) {
    return moment(cellValue).format("yyyy-MM-DD HH:mm");
  }
};

//结果反馈
const feedbackChange = (index, feedback) => {
  UpdateSessionById({
    id: state.QAList[index].id,
    feedback: feedback,
  }).then((res) => {
    if (res.code == 200) {
      state.QAList[index].feedback = feedback;
    } else {
      Notify({ type: "warning", message: res.msg });
    }
  });
};

//复制内容
const copyContent = (content) => {
  const textarea = document.createElement("textarea");
  textarea.value = content.content;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("Copy");
  document.body.removeChild(textarea);
  Notify({ type: "success", message: "已复制到剪贴板！" });
};

const afterRead = (file) => {
  state.showFile = true;
  // let inputHeight = inputRef.value.offsetHeight + 57;
  // recordRef.value.style.height = `calc(100vh - ${inputHeight}px)`;
  console.log(file);
  state.FileList = file.file;
  AIUploadFile({ form: file.file }).then((res) => {
    if (res.code == 200) {
      state.document_Templates = res.data;
    } else {
      state.showFile = false;
      state.document_Templates = "";
      state.FileList = [];

      // let inputHeight = inputRef.value.offsetHeight + 57;
      // recordRef.value.style.height = `calc(100vh - ${inputHeight}px)`;
      Notify({ type: "warning", message: res.msg });
    }
  });
};

const removeFile = () => {
  state.showFile = false;
  // let inputHeight = inputRef.value.offsetHeight + 57;
  // recordRef.value.style.height = `calc(100vh - ${inputHeight}px)`;
  state.FileList = [];
  state.document_Templates = "";
};

// 监听高度变化的回调函数
const handleHeightChange = (height) => {
  console.log("新高度:", height);
  recordRef.value.style.height = `calc(100vh - ${height + 57}px)`;
};

const showWebData = (item) => {
  state.searchWebData = item.search_result;
  state.showWebData = true;
};

const showKmsData = (item) => {
  state.searchKmsData = item.search_result;
  state.showKmsData = true;
};

// 判断是否是链接
const isValidHttpUrl = (string) => {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    console.log("Invalid URL");
    return false;
  }
  console.log(url.protocol);
  return url.protocol === "http:" || url.protocol === "https:";
};

//打开链接
const OpenLink = (res) => {
  //console.log(res, methods.isMarkdown(res));
  if (isValidHttpUrl(res)) {
    window.open(res, "_blank");
  }
};

onMounted(() => {
  ChangeTitle.setTitle("智能办公");
  //加载图片不发送任何原始页面的信息
  const meta = document.createElement("meta");
  meta.setAttribute("name", "referrer");
  meta.setAttribute("content", "no-referrer");
  document.getElementsByTagName("head")[0].appendChild(meta);
  //加载数据
  initData();
  // dd.biz.navigation.close({
  // 				onSuccess: function(result) {
  //           alert('退出成功了')
  // 					console.log(result, 'result')
  // 				},
  // 				onFail: function(err) {
  // 					console.log(err, 'err')
  // 				}
  // 			});
});

onBeforeUnmount(() => {
  // 组件卸载时停止观察
  if (observer) {
    observer.disconnect();
  }
});
</script>


<style scoped lang="scss">
.v-chat-record {
  height: auto;
  overflow: auto;
  bottom: 0;
  background-color: white;

  img {
    height: 28px;
    width: 28px;
  }

  .v-chat-record-item {
    word-wrap: break-word;
    margin: 10px;
    line-height: 25px;
    font-size: 14px;
  }

  .v-chat-record-item-box {
    display: flex;
  }

  .v-chat-record-item-child {
    font-size: medium;
    background-color: #ffffff;
    border-radius: 2px;
    max-width: 75%;
    position: relative;
    padding: 0 10px;
    left: 10px;
    text-align: left;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .empName {
    width: 28px;
    height: 28px;
    background-color: rgb(24, 125, 255);
    text-align: center;
    color: #ffffff;
    border-radius: 5px;
    line-height: 28px !important;
    font-size: small;
  }

  .v-chat-record-right-item {
    position: relative;
    min-height: 40px;
    height: auto;
    margin-top: 10px;

    .v-chat-record-item-box {
      justify-content: flex-end;
    }

    .v-chat-record-item-child {
      font-size: medium;
      position: relative;
      left: -10px;
      padding: 0 10px;
      background-color: #eff6ff;
    }
  }
}
.vant-table {
  overflow-x: auto;
  padding: 10px 0;

  table {
    width: auto;
    padding: 5px;

    border-collapse: collapse;

    tr {
      line-height: 30px;
    }

    .th {
      height: 30px;
      line-height: 30px;
      background-color: #f5f6f6;
      text-align: center;
    }

    td {
      text-align: center;
      border-bottom: 1px solid #f5f6f6;
    }

    // td:first-child {
    //   background-color: #fff;
    //   position: sticky;
    //   left: 0px;
    // }

    // th:first-child {
    //   position: sticky;
    //   left: 0px;
    // }

    .link-text {
      color: #0089ff;
    }
  }
}
.v-chat-input {
  overflow: auto;

  background-color: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  box-sizing: border-box;

  .van-cell-group {
    .van-field {
      padding: 10px 0px;
    }
  }

  .btn {
    text-align: right;
  }
}

.upg {
  position: absolute;
  font-size: 20px;
  right: 5px;
  bottom: 50px;
  cursor: pointer;
}

.upg:active {
  color: red;
}

.popoverTitle {
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  margin: 10px 0;
}

.box {
  width: 100%;

  padding: 10px 0;
  background-color: #eee;
  border-radius: 10px;

  .recordBoxTop {
    display: flex;
    justify-content: space-around;
    background-color: #1890ff;
    color: #fff;
    font-weight: 600;
    padding-left: 10px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;

    :nth-child(1) {
      width: 60px;
      text-align: center;
    }
  }

  .recordBox {
    display: flex;
    justify-content: space-around;
    cursor: pointer;
    text-align: center;
    font-size: 12px;
    height: 30px;
    line-height: 30px;

    :nth-child(1) {
      flex: 1.1;
      text-align: center;
    }

    :nth-child(2) {
      flex: 1;
    }

    :nth-child(3) {
      flex: 1;
    }
  }
}

::v-deep .van-empty__image {
  width: 120px !important;
}

::v-deep .van-empty__description {
  font-size: 15px;
  padding-top: 10px;
}
</style>